export const getGroupParams = ({ teamId, divisionId }) => ({
  ...(teamId && { teamId }),
  ...(divisionId && { divisionId }),
});

export const getGroupId = ({ teamId, divisionId }) => teamId || divisionId;

export const getGroupType = (params) => Object.keys(getGroupParams(params))[0];
